/* Beyond Radix - Knee Recovery Kit landing page interactions */
(function () {
  if (window.__bkInit) return;
  window.__bkInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* reveal on scroll */
  function reveal() {
    var els = $all('.bk [data-bk-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* counters */
  function counters() {
    var els = $all('.bk [data-bk-count]');
    if (!els.length) return;
    function run(el) {
      var to = parseFloat(el.getAttribute('data-bk-count')) || 0;
      var dec = (String(to).split('.')[1] || '').length;
      if (reduce) { el.textContent = to.toFixed(dec); return; }
      var t0 = null, dur = 1600;
      function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var v = to * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* hero tilt with the pointer */
  function tilt() {
    if (reduce) return;
    $all('[data-bk-tilt]').forEach(function (wrap) {
      var stage = wrap.querySelector('.bk-hero__stage');
      if (!stage) return;
      wrap.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = wrap.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        stage.style.transform = 'rotateY(' + (x * 12) + 'deg) rotateX(' + (-y * 12) + 'deg)';
      });
      wrap.addEventListener('pointerleave', function () { stage.style.transform = ''; });
    });
    $all('.bk-tile').forEach(function (t) {
      t.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var r = t.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        t.style.transform = 'perspective(900px) rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg) translateY(-4px)';
      });
      t.addEventListener('pointerleave', function () { t.style.transform = ''; });
    });
  }

  /* pain map hotspots */
  function painMap() {
    $all('[data-bk-map]').forEach(function (root) {
      var spots = $all('[data-bk-spot]', root);
      var panes = $all('[data-bk-pane]', root);
      var auto = null, touched = false;
      function show(id) {
        spots.forEach(function (s) { var on = s.getAttribute('data-bk-spot') === id; s.classList.toggle('is-active', on); s.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        panes.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-bk-pane') === id); });
      }
      spots.forEach(function (s) {
        s.addEventListener('click', function () { touched = true; clearInterval(auto); show(s.getAttribute('data-bk-spot')); });
      });
      if (spots.length) show(spots[0].getAttribute('data-bk-spot'));
      if (!reduce && spots.length > 1) {
        var i = 0;
        auto = setInterval(function () {
          if (touched) return clearInterval(auto);
          var r = root.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          i = (i + 1) % spots.length;
          show(spots[i].getAttribute('data-bk-spot'));
        }, 4200);
      }
    });
  }

  /* phases progress line */
  function phases() {
    $all('[data-bk-phases]').forEach(function (root) {
      var line = root.querySelector('.bk-phases__line i');
      var items = $all('.bk-phase', root);
      var ticking = false;
      function paint() {
        ticking = false;
        var r = root.getBoundingClientRect();
        var mid = window.innerHeight * 0.6;
        var p = Math.max(0, Math.min(1, (mid - r.top) / r.height));
        if (line) line.style.setProperty('--p', (p * 100).toFixed(1) + '%');
        items.forEach(function (it) {
          var ir = it.getBoundingClientRect();
          it.classList.toggle('is-lit', ir.top + ir.height * 0.35 < mid);
        });
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
      window.addEventListener('resize', paint);
      paint();
    });
  }

  /* add to cart (falls back to the normal form post without JS) */
  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function buy() {
    $all('form[data-bk-buy]').forEach(function (form) {
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.querySelector('[data-bk-label]') : null;
      var msg = form.querySelector('.bk__msg');
      var unit = parseInt(form.getAttribute('data-price'), 10) || 0;
      var cmp = parseInt(form.getAttribute('data-compare'), 10) || 0;
      var priceEl = form.querySelector('[data-bk-price]');
      var cmpEl = form.querySelector('[data-bk-compare]');
      $all('input[name="quantity"][type="radio"]', form).forEach(function (r) {
        r.addEventListener('change', function () {
          var q = parseInt(r.value, 10) || 1;
          if (priceEl) priceEl.textContent = money(unit * q);
          if (cmpEl && cmp) cmpEl.textContent = money(cmp * q);
          if (label) label.textContent = label.getAttribute('data-base') + ' · ' + money(unit * q);
        });
      });
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var fd = new FormData(form);
        var id = fd.get('id');
        var qty = parseInt(fd.get('quantity'), 10) || 1;
        if (btn) btn.disabled = true;
        if (msg) msg.textContent = '';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to cart');
            window.location.href = form.getAttribute('data-next') || '/cart';
          })
          .catch(function (err) {
            if (btn) btn.disabled = false;
            if (msg) msg.textContent = err.message;
          });
      });
    });
  }

  /* sticky buy bar: shows after the hero, hides while the offer is on screen */
  function sticky() {
    var bar = document.querySelector('[data-bk-sticky]');
    if (!bar) return;
    var hero = document.querySelector('[data-bk-hero-buy]');
    var offer = document.querySelector('[data-bk-offer]');
    var heroOut = false, offerIn = false;
    function upd() { bar.classList.toggle('is-on', heroOut && !offerIn); }
    if (!('IntersectionObserver' in window)) return;
    if (hero) new IntersectionObserver(function (es) { heroOut = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; upd(); }).observe(hero);
    else heroOut = true;
    if (offer) new IntersectionObserver(function (es) { offerIn = es[0].isIntersecting; upd(); }, { threshold: 0.15 }).observe(offer);
    upd();
  }

  function init() {
    document.documentElement.classList.remove('bk-no-js');
    reveal(); counters(); tilt(); painMap(); phases(); buy(); sticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { reveal(); counters(); painMap(); phases(); buy(); sticky(); });
})();
